import { render, staticRenderFns } from "./WakeoLogo.vue?vue&type=template&id=642095b4&"
import script from "./WakeoLogo.vue?vue&type=script&lang=js&"
export * from "./WakeoLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports